import { useCallback } from "react";

import { useBackgroundLocation } from "../home/components/UseBackgroundLocation";
import { routeCreators } from "../routes/AppRoutes";
import { isOnManagePage } from "../routes/routeUtils";
import { useAppNavigate } from "./useAppNavigate";

export const useRedirectToManagePage = () => {
  const { push } = useAppNavigate();
  const location = useBackgroundLocation();
  return useCallback(() => {
    if (!isOnManagePage(location)) {
      push(routeCreators.bookings());
    }
  }, [location, push]);
};
